import axios from "axios";
import { service_url, cookieValue, URLJoin } from "./const";

async function RestPut(route_path, body) {
  let full_url = URLJoin(service_url, route_path);

  const config = {
    headers: {
      cookie: cookieValue,
      "Content-Type": "application/json",
    },
  };
  const { data } = await axios.put(full_url, body, config);
  return data;
}

export default RestPut;
